<script>
  import { asnavigate } from '../Utils/asnavigation.js';
  import { useNavigate } from 'svelte-navigator';
  const navigate = useNavigate();
  import { contactIsOpen } from '../stores.js';

  let current = '';

  function toggleContact() {
    // console.log(` toggleContact ${$contactIsOpen}`);
    const btnContact = document.querySelector('.as-btn-contact');
    // btnContact.classList.add('disabled');
    navigate('../contact');
    // if ($contactIsOpen) navigate(-1);
    // else navigate('../contact');
  }
    import { onMount } from 'svelte';

  // État des dropdowns desktop
  let openDropdown = null;
  
  // État du menu mobile
  let mobileMenuOpen = false;
  
  // État des dropdowns mobile
  let openMobileDropdown = null;

  // Fonction pour basculer un dropdown desktop
  function toggleDropdown(dropdownName) {
    if (openDropdown === dropdownName) {
      openDropdown = null;
    } else {
      openDropdown = dropdownName;
    }
  }

  // Fonction pour basculer le menu mobile
  function toggleMobileMenu() {
    mobileMenuOpen = !mobileMenuOpen;
    // Fermer les dropdowns mobiles quand on ferme le menu
    if (!mobileMenuOpen) {
      openMobileDropdown = null;
    }
  }

  // Fonction pour basculer un dropdown mobile
  function toggleMobileDropdown(dropdownName) {
    if (openMobileDropdown === dropdownName) {
      openMobileDropdown = null;
    } else {
      openMobileDropdown = dropdownName;
    }
  }

  // Fonction pour fermer le menu mobile quand on clique sur un lien
  function closeMobileMenu() {
    mobileMenuOpen = false;
    openMobileDropdown = null;
  }

  // Fermer les dropdowns en cliquant ailleurs
  function handleClickOutside(event) {
    // Vérifier si le clic est à l'extérieur des dropdowns
    const target = event.target;
    const isDropdownClick = target.closest('.dropdown') || target.closest('.mobile-dropdown-btn');
    
    if (!isDropdownClick) {
      openDropdown = null;
    }
  }

  onMount(() => {
    // Ajouter l'event listener pour fermer les dropdowns
    document.addEventListener('click', handleClickOutside);
    
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  });
</script>


<div class="as-container mx-auto">
  <div class="" style="position: absolute;top: 10px;z-index: 9999;">
    <a href="https://www.semin.fr/" class="as-header-left fancy-link svelte-a2bgxc">
      <iconify-icon icon="codicon:arrow-small-left" width="25" height="25" style="margin-top: -3px;">
        <template shadowrootmode="open">
          <style data-style="data-style">:host{display:inline-block;vertical-align:0}span,svg{display:block}</style>
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 16 16">
            <path fill="currentColor" d="M6.5 10.7L4 8.2v-.7L6.5 5l.71.7l-1.64 1.65h5.57v1H5.57L7.22 10z"></path>
          </svg>
        </template>
      </iconify-icon>
      Site principal Semin
    </a>
  </div>
</div>

<nav id="header" class="relative w-full z-30 top-0 shadow-xl svelte-a2bgxc">
  <div class="as-container mx-auto">
    <div class="as-header-desk as-header-grid grid grid-cols-4 gap-4 content-center svelte-a2bgxc">
      <div>
        <div>
          <img src="../statics/logo-trappes.svg" alt="Semin logo" class="as-logo mx-auto">
        </div>
      </div>
      
      <div class="as-header-center-menu as-header-middle col-span-2 text-center svelte-a2bgxc">
        <div class="as-menu hidden md:flex items-center space-x-8">
          <a href="https://comptoirtrappe.fr/" class="as-menu-titre text-gray-700 hover:text-blue-600 px-3 py-2 transition duration-300">
            Accueil
          </a>
          
          <!-- Dropdown Trappes -->
          <div class="relative dropdown">
            <button 
              class="as-menu-titre flex items-center text-gray-700 hover:text-blue-600 px-3 py-2 transition duration-300 dropdown-btn"
              on:click|preventDefault={() => toggleDropdown('trappes')}
            >
              Trappes
              <svg 
                class="ml-1 w-4 h-4 transform transition-transform duration-200 chevron" 
                class:rotate-180={openDropdown === 'trappes'}
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </button>
            <div 
              class="as-sousmenu absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg z-50 transition-all duration-200 dropdown-menu"
              class:opacity-100={openDropdown === 'trappes'}
              class:visible={openDropdown === 'trappes'}
              class:translate-y-0={openDropdown === 'trappes'}
              class:opacity-0={openDropdown !== 'trappes'}
              class:invisible={openDropdown !== 'trappes'}
              class:translate-y-1={openDropdown !== 'trappes'}
            >
              <div class="py-1">
                <a href="site/nos-trappes-de-visite.php" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-blue-600 transition">Nos trappes</a>
                <a href="site/trappe-de-visite-metallique.php" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-blue-600 transition">Métallique</a>
                <a href="site/trappe-de-visite-alu-hydro.php" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-blue-600 transition">Alu hydro</a>
                <a href="site/trappe-de-visite-vide-sanitaire.php" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-blue-600 transition">Vide sanitaire</a>
                <a href="site/trappe-de-visite-multi-etancheites.php" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-blue-600 transition">Multi-étanchéités</a>
                <a href="site/trappe-de-visite-coupe-feu.php" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-blue-600 transition">Coupe feu</a>
              </div>
            </div>
          </div>
          
          <!-- Dropdown Services -->
          <div class="relative dropdown">
            <button 
              class="as-menu-titre flex items-center text-gray-700 hover:text-blue-600 px-3 py-2 transition duration-300 dropdown-btn"
              on:click|preventDefault={() => toggleDropdown('services')}
            >
              Services
              <svg 
                class="ml-1 w-4 h-4 transform transition-transform duration-200 chevron"
                class:rotate-180={openDropdown === 'services'}
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </button>
            <div 
              class="as-sousmenu absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg z-50 transition-all duration-200 dropdown-menu"
              class:opacity-100={openDropdown === 'services'}
              class:visible={openDropdown === 'services'}
              class:translate-y-0={openDropdown === 'services'}
              class:opacity-0={openDropdown !== 'services'}
              class:invisible={openDropdown !== 'services'}
              class:translate-y-1={openDropdown !== 'services'}
            >
              <div class="py-1">
                <a href="site/trappe-de-visite-sur-mesure.php" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-blue-600 transition">Sur mesure</a>
                <a href="site/delai-de-livraison.php" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-blue-600 transition">Délai de livraison</a>
                <a href="https://comptoirtrappe.fr/distributeurs/" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-blue-600 transition">Trouver un revendeur</a>
                <a href="https://comptoirtrappe.fr/faq" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-blue-600 transition">FAQ</a>
              </div>
            </div>
          </div>
          
          <a href="site/blog.php" class="as-menu-titre text-gray-700 hover:text-blue-600 px-3 py-2 transition duration-300">
            Blog
          </a>
        </div>
      </div>
      
      <div class="as-header-right svelte-a2bgxc">
        <a href="https://comptoirtrappe.fr/contact" class="as-btn-contact mx-auto svelte-a2bgxc">
          <span class="asphone">
            <iconify-icon icon="ci:mail">
              <template shadowrootmode="open">
                <style data-style="data-style">:host{display:inline-block;vertical-align:0}span,svg{display:block}</style>
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                  <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m4 6l6.108 4.612l.002.002c.678.497 1.017.746 1.389.842a2 2 0 0 0 1.002 0c.372-.096.712-.345 1.392-.844c0 0 3.917-3.006 6.107-4.612M3 15.8V8.2c0-1.12 0-1.68.218-2.108c.192-.377.497-.682.874-.874C4.52 5 5.08 5 6.2 5h11.6c1.12 0 1.68 0 2.107.218c.377.192.683.497.875.874c.218.427.218.987.218 2.105v7.607c0 1.118 0 1.676-.218 2.104a2 2 0 0 1-.875.874c-.427.218-.986.218-2.104.218H6.197c-1.118 0-1.678 0-2.105-.218a2 2 0 0 1-.874-.874C3 17.48 3 16.92 3 15.8"></path>
                </svg>
              </template>
            </iconify-icon>
          </span>
          <span class="asdesk">NOUS CONTACTER</span>
        </a>
        
        <!-- Bouton menu mobile -->
        <div class="md:hidden">
          <button 
            class="mobile-menu-btn text-gray-700 hover:text-blue-600 focus:outline-none"
            on:click={toggleMobileMenu}
          >
            <svg 
              class="w-6 h-6 hamburger-icon" 
              class:hidden={mobileMenuOpen}
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
            <svg 
              class="w-6 h-6 close-icon" 
              class:hidden={!mobileMenuOpen}
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</nav>

<!-- Menu mobile -->
<div class="md:hidden mobile-menu" class:hidden={!mobileMenuOpen}>
  <div class="px-2 pt-2 pb-3 space-y-1 bg-white border-t border-gray-200">
    <a 
      href="https://comptoirtrappe.fr/" 
      class="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md transition"
      on:click={closeMobileMenu}
    >
      Accueil
    </a>
    
    <!-- Trappes Mobile avec sous-menu -->
    <div>
      <button 
        class="w-full flex items-center justify-between px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md transition mobile-dropdown-btn"
        on:click|preventDefault={() => toggleMobileDropdown('trappes')}
      >
        <span>Trappes</span>
        <svg 
          class="w-4 h-4 transform transition-transform duration-200 mobile-chevron"
          class:rotate-180={openMobileDropdown === 'trappes'}
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
        </svg>
      </button>
      
      <!-- Sous-menu mobile -->
      <div 
        class="mobile-dropdown-menu pl-4 mt-1 space-y-1" 
        class:hidden={openMobileDropdown !== 'trappes'}
      >
        <a href="site/nos-trappes.php" class="block px-3 py-2 text-sm text-gray-600 hover:text-blue-600 hover:bg-gray-50 rounded-md transition" on:click={closeMobileMenu}>
          Nos trappes
        </a>
        <a href="site/trappe-metallique.php" class="block px-3 py-2 text-sm text-gray-600 hover:text-blue-600 hover:bg-gray-50 rounded-md transition" on:click={closeMobileMenu}>
          Métallique
        </a>
        <a href="site/trappe-alu-hydro.php" class="block px-3 py-2 text-sm text-gray-600 hover:text-blue-600 hover:bg-gray-50 rounded-md transition" on:click={closeMobileMenu}>
          Alu hydro
        </a>
        <a href="site/trappe-vide-sanitaire.php" class="block px-3 py-2 text-sm text-gray-600 hover:text-blue-600 hover:bg-gray-50 rounded-md transition" on:click={closeMobileMenu}>
          Vide sanitaire
        </a>
        <a href="trappe-multi-etancheites.php" class="block px-3 py-2 text-sm text-gray-600 hover:text-blue-600 hover:bg-gray-50 rounded-md transition" on:click={closeMobileMenu}>
          Multi-étanchéités
        </a>
        <a href="site/trappe-coupe-feu.php" class="block px-3 py-2 text-sm text-gray-600 hover:text-blue-600 hover:bg-gray-50 rounded-md transition" on:click={closeMobileMenu}>
          Coupe feu
        </a>
      </div>
    </div>
    
    <!-- Services Mobile avec sous-menu -->
    <div>
      <button 
        class="w-full flex items-center justify-between px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md transition mobile-dropdown-btn"
        on:click|preventDefault={() => toggleMobileDropdown('services')}
      >
        <span>Services</span>
        <svg 
          class="w-4 h-4 transform transition-transform duration-200 mobile-chevron"
          class:rotate-180={openMobileDropdown === 'services'}
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
        </svg>
      </button>
      
      <!-- Sous-menu mobile -->
      <div 
        class="mobile-dropdown-menu pl-4 mt-1 space-y-1" 
        class:hidden={openMobileDropdown !== 'services'}
      >
        <a href="site/sur-mesure.php" class="block px-3 py-2 text-sm text-gray-600 hover:text-blue-600 hover:bg-gray-50 rounded-md transition" on:click={closeMobileMenu}>
          Sur mesure
        </a>
        <a href="site/delai-de-livraison.php" class="block px-3 py-2 text-sm text-gray-600 hover:text-blue-600 hover:bg-gray-50 rounded-md transition" on:click={closeMobileMenu}>
          Délai de livraison
        </a>
        <a href="trouver-un-revendeur.php" class="block px-3 py-2 text-sm text-gray-600 hover:bg-gray-50 rounded-md transition" on:click={closeMobileMenu}>
          Trouver un revendeur
        </a>
        <a href="https://comptoirtrappe.fr/faq" class="block px-3 py-2 text-sm text-gray-600 hover:text-blue-600 hover:bg-gray-50 rounded-md transition" on:click={closeMobileMenu}>
          FAQ
        </a>
      </div>
    </div>
    
    <a 
      href="site/blog.php" 
      class="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md transition"
      on:click={closeMobileMenu}
    >
      Blog
    </a>
  </div>
</div>

<!-- 
<nav id="header" class="relative w-full z-30 top-0 shadow-xl">
  <div class="as-container mx-auto">
    <div
      class="as-header-desk as-header-grid grid grid-cols-4 gap-4 content-center "
    >
      <div
        class="as-header-left fancy-link"
        on:click="{() => window.open('https://www.semin.fr/')}"
      >
        <iconify-icon
          icon="codicon:arrow-small-left"
          width="25"
          height="25"
          style="margin-top: -3px;"></iconify-icon>
        Site principal Semin
      </div>
      <div
        class="as-header-middle col-span-2 text-center "
        on:click="{() => asnavigate(navigate, '/')}"
      >
        <img
          src="./statics/logo-trappes.svg"
          alt="Semin logo"
          class="logo mx-auto"
        />
      </div>
      <div class="as-header-right">
        <div
          class="as-btn-contact mx-auto"
          on:click="{() => {
            toggleContact();
            current = 'disabled';
          }}"
        >
          <span class="asphone"
            ><iconify-icon icon="ci:mail"></iconify-icon></span
          >
          <span class="asdesk">NOUS CONTACTER</span>
        </div>

        <div
          class="wrapper-faq"
          on:click="{() => {
            navigate('../../faq');
          }}"
        >
          <div in:fly="{{ delay: 3000, y: 100, duration: 1500 }}">
            <div
              class="as-btn-faq"
              on:click="{() => {
                navigate('../../faq');
              }}"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 24 24"
                ><path
                  fill="currentColor"
                  d="M10.6 16q0-2.025.363-2.913q.362-.887 1.537-1.937q1.025-.9 1.562-1.563q.538-.662.538-1.512q0-1.025-.687-1.7Q13.225 5.7 12 5.7q-1.275 0-1.938.775q-.662.775-.937 1.575L6.55 6.95q.525-1.6 1.925-2.775Q9.875 3 12 3q2.625 0 4.038 1.463q1.412 1.462 1.412 3.512q0 1.25-.537 2.138q-.538.887-1.688 2.012Q14 13.3 13.738 13.912q-.263.613-.263 2.088Zm1.4 6q-.825 0-1.412-.587Q10 20.825 10 20q0-.825.588-1.413Q11.175 18 12 18t1.413.587Q14 19.175 14 20q0 .825-.587 1.413Q12.825 22 12 22Z"
                ></path></svg
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="as-header-phone as-header-container content-center gap-4">
      <div class="headertop">
        <div
          class="as-header-left fancy-link"
          on:click="{() => window.open('https://www.semin.fr/')}"
        >
          <iconify-icon
            icon="codicon:arrow-small-left"
            width="25"
            height="25"
            style="margin-top: -3px;"></iconify-icon>
          Site principal Semin
        </div>
      </div>
      <div class="headerlogo">
        <div
          class="as-header-middle col-span-2 text-center "
          on:click="{() => asnavigate(navigate, '/')}"
        >
          <img
            src="./statics/logo-trappes.svg"
            alt="Semin logo"
            class="logo mx-auto"
          />
        </div>
      </div>
      <div class="headercontact">
        <div
          class="as-btn-contact mx-auto"
          on:click="{() => {
            toggleContact();
            current = 'disabled';
          }}"
        >
          <span class="asphone"
            ><iconify-icon icon="ci:mail"></iconify-icon></span
          >
          <span class="asdesk">NOUS CONTACTER</span>
        </div>
      </div>

      <div class="headerfaq">
        <div
          class="as-btn-faq"
          on:click="{() => {
            navigate('../../faq');
          }}"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 24 24"
            ><path
              fill="currentColor"
              d="M10.6 16q0-2.025.363-2.913q.362-.887 1.537-1.937q1.025-.9 1.562-1.563q.538-.662.538-1.512q0-1.025-.687-1.7Q13.225 5.7 12 5.7q-1.275 0-1.938.775q-.662.775-.937 1.575L6.55 6.95q.525-1.6 1.925-2.775Q9.875 3 12 3q2.625 0 4.038 1.463q1.412 1.462 1.412 3.512q0 1.25-.537 2.138q-.538.887-1.688 2.012Q14 13.3 13.738 13.912q-.263.613-.263 2.088Zm1.4 6q-.825 0-1.412-.587Q10 20.825 10 20q0-.825.588-1.413Q11.175 18 12 18t1.413.587Q14 19.175 14 20q0 .825-.587 1.413Q12.825 22 12 22Z"
            ></path></svg
          >
        </div>
      </div>
    </div>
  </div>
</nav> -->


<style>
    .rotate-180 {
    transform: rotate(180deg);
  }

  .as-header-container {
    /* padding: 15px 15px 0; */
    padding: 15px;
    display: grid;
    grid-template-columns: 2.5fr repeat(2, 0.25fr);
    grid-template-rows: 0.5fr 1.5fr;
    gap: 12px;
    grid-auto-flow: row;
    justify-content: stretch;
    align-content: stretch;
    /* justify-items: stretch;
    align-items: stretch; */
    place-items: center;
    grid-template-areas:
      'headertop headertop headertop'
      'headerlogo headercontact headerfaq';
  }

  .as-btn-faq {
    cursor: pointer;
    box-shadow: 0 0 0 2px #000;
    border-radius: 9999px;
    padding: 11px;
    transition: all 300ms;
  }
  .as-btn-faq:hover {
    box-shadow: 0 0 0 5px #000;
  }
  .wrapper-faq {
    padding-right: 10px;
  }
  #header {
    background-color: rgb(255 255 255 / 80%);
  }
  .logo {
    width: 100%;
    max-width: 500px;
    height: 150px;
    cursor: pointer;
  }
  .as-header-grid {
    height: 150px;
  }
  .as-header-left,
  .as-header-right {
    display: flex;
    align-items: center;
    font-size: 14px;
    text-transform: uppercase;
    transition: color 300ms;
  }
  .as-header-left {
    position: relative;
    text-decoration: none;
    background-color: transparent;
    transition: opacity 200ms, padding 500ms, transform 500ms,
      background-color 1000ms;
  }
  .as-header-left:hover {
    /* transform: scale(1.01); */
    transform-origin: bottom;
  }
  .as-header-left::before {
    content: '';
    position: absolute;
    width: 200px;
    top: calc(50% + 10px);
    border-bottom: 0.1rem solid #000;
    transform-origin: right;
    transform: scalex(0);
    transition: transform 400ms;
  }
  .as-header-left:hover::before {
    transform: scalex(1);
    transform-origin: left;
  }
  .as-btn-contact {
    padding: 25px 20px;
    background-color: #000;
    color: #fff;
    text-transform: uppercase;
    transition: all 300ms;
  }
  .as-header-left,
  .as-btn-contact {
    cursor: pointer;
  }
  .as-btn-contact:hover {
    background-color: #fff;
    color: #000;
    border: 3px solid #000;
  }
  .as-btn-contact.disabled {
    opacity: 0;
    visibility: hidden;
  }

  .as-header-desk {
    display: grid;
  }
  .as-header-phone {
    display: none;
  }

  @media only screen and (max-width: 1060px) {
    /* .wrapper-faq {
      padding-left: 10px;
    } */
  }
  @media only screen and (max-width: 768px) {
    .as-header-desk {
      display: none;
    }
    .as-header-phone {
      display: grid;
    }

    .wrapper-faq {
      position: absolute;
      top: 10px;
      right: 9vw;
    }
    .as-header-grid {
      height: auto;
      padding: 10px;
      gap: 0;
    }
    .as-btn-faq {
      padding: 8px;
    }
    .as-btn-faq svg {
      width: 30px;
      height: 30px;
    }
    .as-header-left {
      margin: 0 0 5px;
      grid-column: span 4 / span 4;
    }
    .as-header-middle {
      grid-column: span 3 / span 3;
    }
    .logo {
      width: 900px;
      max-width: 100%;
      height: auto;
      cursor: pointer;
    }
    .as-header-right {
      padding: 10px;
    }
    .as-btn-contact {
      font-size: 27px;
      padding: 10px 15px 0;
    }

    .headertop {
      width: 100%;
      grid-area: headertop;
    }

    .headerlogo {
      grid-area: headerlogo;
    }

    .headercontact {
      grid-area: headercontact;
    }

    .headerfaq {
      grid-area: headerfaq;
    }
  }
  @media only screen and (max-width: 660px) {
    .wrapper-faq {
      right: 7vw;
    }
  }
  .as-header-center-menu {
    display: grid;
    place-items: center;
}

.as-menu .as-menu-titre {
    text-transform: uppercase;
}

.as-sousmenu {
    text-align: left;
}

.as-logo {
    padding-left: 10px;
}

.as-content {
    padding: 80px;
    min-height: 600px;
}

.as-texte a:not(.as-btn-rounded, .as-link-blog) {
    color: #0c4b9b;
    border-bottom: 1px dashed #0071ff;
    transition: all 200ms ease-in-out;
}

.as-texte a:hover:not(.as-btn-rounded, .as-link-blog) {
    color: #0071ff;
    border-bottom: 1px dashed #9dc9ff;
}

.as-texte h2 {
    font-size: 30px;
    margin: 35px 0 15px;
}

.as-texte h3 {
    font-size: 20px;
    margin: 35px 0 15px;
    color: #0c4b9b;
}

.as-texte p {
    text-align: justify;
    margin-bottom: 10px;
}

.as-texte ul {
    list-style: none;
    padding-left: 0;
    margin: 0 0 0 10px;
}

.as-texte ul li {
    position: relative;
    padding-left: 25px;
    margin: 10px 0;
    line-height: 1.5;
}

.as-texte ul li::before {
    content: "";
    width: 6px;
    height: 6px;
    background-color: #333;
    border-radius: 50%;
    position: absolute;
    left: 6px;
    top: 9px;
}

.as-texte ol {
    list-style: none;
    padding-left: 0;
    margin: 0 0 0 10px;
    counter-reset: list-counter;
}

.as-texte ol li {
    position: relative;
    padding-left: 25px;
    margin: 10px 0;
    line-height: 1.5;
    counter-increment: list-counter;
}

.as-texte ol li::before {
    content: counter(list-counter) ".";
    position: absolute;
    left: 0;
    top: 0;
    color: #333;
    font-weight: bold;
    min-width: 25px;
}

.as-texte .table-container {
    overflow-x: auto;
    margin: 20px 0;
}

.as-texte table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #333;
    font-family: Arial, sans-serif;
}

.as-texte th,
.as-texte td {
    border: 1px solid #333;
    padding: 10px;
    text-align: center;
}

.as-texte th {
    background-color: #f4f4f4;
    font-weight: bold;
}

.as-texte h2.as-blog-titre {
    margin: 0;
    font-size: 15px;
    line-height: 20px;
}

.as-titre-article {
    font-size: 60px !important;
    line-height: 40px !important;
}

.copyright a {
    border-bottom: 0 solid #fff;
    transition: all .3s;
}

.copyright a:hover {
    color: #fff;
    border-bottom: 1px solid #fff;
}

@media only screen and (max-width: 992px) {
    .as-menu .as-menu-titre,
    .as-menu .dropdown {
        padding: 0;
        margin: 0 0 0 10px !important;
    }
}

@media only screen and (max-width: 768px) {
    .as-header-desk.svelte-a2bgxc.svelte-a2bgxc {
        display: grid;
        grid-template-columns: 2fr 1fr;
    }
    .as-header-center-menu {
        display: none;
    }
    .as-header-right {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 20px;
    }
    .wrapper-faq.svelte-a2bgxc.svelte-a2bgxc {
        position: relative;
        right: 0;
        top: 0;
    }
    .as-header-left.svelte-a2bgxc.svelte-a2bgxc {
        display: none;
        /* position: absolute;
        top: 0;
        font-size: 9px;
        left: 5px; */
    }
    .as-content {
        padding: 0 30px;
    }
}

@media only screen and (max-width: 540px) {
    .as-header-right {
        gap: 5px;
    }
    .as-btn-contact.svelte-a2bgxc.svelte-a2bgxc {
        font-size: 17px;
    }
    .as-btn-faq.svelte-a2bgxc svg.svelte-a2bgxc {
        height: 20px;
        width: 20px;
    }
    .as-btn-rounded.svelte-1hki9bc.svelte-1hki9bc {
        text-align: center;
    }
}
</style>
